import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { ExperienceTransactionGameDrawDetailsFragmentFragment } from "../../../hooks/useXPTransactions/graphql/XPTransactionsFragment.generated";

export const ExperienceTransactionGameDrawDetails = ({
  details,
  earnedXP,
  totalXP,
}: {
  details: ExperienceTransactionGameDrawDetailsFragmentFragment;
  earnedXP: number;
  totalXP: number;
}) => {
  const { t } = useTranslation();

  return (
    <Trans
      i18nKey="xp_transaction.ExperienceTransactionGameDrawDetails"
      components={{
        xp: <span className="font-bold" />,
        total: <span className="font-bold" />,
        game: <span className="font-bold" />,
      }}
      values={{
        xp: earnedXP,
        total: totalXP,
        game: t(`game.${details.gameId}`),
      }}
    />
  );
};
